import { HttpClient } from '@angular/common/http';
import { Injectable, Optional, SkipSelf } from '@angular/core';
import { BehaviorSubject, firstValueFrom, tap } from 'rxjs';
import { Configuration } from '@app/shared/models/Configuration.model';
import { LoggerService } from '@app/blocks/logger/services/logger.service';

@Injectable()
export class ConfigurationService {
    public isLoading = new BehaviorSubject<boolean>(true);
    private config: Configuration | null = null;

    appErrorPrefix = '[NG-Connect Error] ';

    constructor(
        private http: HttpClient,
        private logger: LoggerService,
        @Optional() @SkipSelf() configurationService?: ConfigurationService
    ) {
        if (configurationService) {
            throw new Error('ConfigurationService is already loaded');
        }
    }

    requestConfiguration() {
        this.logger.info("_configurationService: config requested");

        const configUrl = "https://" + window.location.host + "/umbraco/api/clientconfiguration"

        return firstValueFrom(this.http.get<Configuration>(`${configUrl}/appshell`).pipe(
            tap(
                (c: Configuration) => {
                    this.config = c;
                }
            )
        ));
    }

    getConfig() {
        if (this.config === null) {
            this.logger.error("_configurationService: null config!", this.config);
        }

        return this.config;
    }
}
